export { default } from './JoinIntegrationPage';
